import State from "../state"

export const isLoading = (state: State) => state.surveyTypes.loading
export const errors = (state: State) => state.surveyTypes.errors
export const surveyTypes = (state: State) => state.surveyTypes.data
export const surveyType = (id: string) => (state: State) =>
  state.surveyTypes.data.find(surveyType => surveyType.id === id)
